"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var LoadingTile_styles_1 = require("./LoadingTile.styles");
var MerchTile_styles_1 = require("../MerchTile/MerchTile.styles");
function LoadingTile() {
    return (react_1.default.createElement("div", { "data-package": "merch-tile", className: "animate-pulse" },
        react_1.default.createElement(MerchTile_styles_1.TileContainer, null,
            react_1.default.createElement(MerchTile_styles_1.TileContentWrapper, null,
                react_1.default.createElement(LoadingTile_styles_1.VehicleImage, null),
                react_1.default.createElement(LoadingTile_styles_1.VehicleInfoContainer, null,
                    react_1.default.createElement("section", { className: "flex flex-col gap-4" },
                        react_1.default.createElement(LoadingTile_styles_1.YearMakeModel, null),
                        react_1.default.createElement(LoadingTile_styles_1.TrimMileage, null)),
                    react_1.default.createElement("section", { className: "flex items-end justify-between" },
                        react_1.default.createElement(LoadingTile_styles_1.Price, null),
                        react_1.default.createElement("p", { className: "flex flex-col items-end" },
                            react_1.default.createElement(LoadingTile_styles_1.MonthlyPayment, null),
                            react_1.default.createElement(LoadingTile_styles_1.DownPayment, null))),
                    react_1.default.createElement(LoadingTile_styles_1.ShippingInfo, null))))));
}
exports.default = LoadingTile;
//# sourceMappingURL=LoadingTile.js.map